var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71665 11.8059H10.4667C10.4667 11.6349 10.4082 11.469 10.301 11.3358L9.71665 11.8059ZM4.44546 5.25365L5.02983 4.78353L5.02983 4.78353L4.44546 5.25365ZM19.5833 5.21668L18.9881 4.76042L18.9881 4.76042L19.5833 5.21668ZM14.6493 11.654L14.054 11.1978C13.9536 11.3287 13.8993 11.4891 13.8993 11.654H14.6493ZM14.6493 19.3269L15.0066 19.9863C15.2486 19.8552 15.3993 19.6021 15.3993 19.3269H14.6493ZM9.71665 22H8.96665C8.96665 22.2644 9.10581 22.5092 9.33293 22.6444C9.56005 22.7797 9.84159 22.7854 10.074 22.6594L9.71665 22ZM10.301 11.3358L5.02983 4.78353L3.86109 5.72376L9.13228 12.276L10.301 11.3358ZM5.02983 4.78353C4.37184 3.96563 4.95406 2.75 6.00378 2.75V1.25C3.6944 1.25 2.41351 3.92438 3.86109 5.72376L5.02983 4.78353ZM6.00378 2.75H17.996V1.25H6.00378V2.75ZM17.996 2.75C19.0321 2.75 19.6184 3.9381 18.9881 4.76042L20.1786 5.67293C21.5652 3.86381 20.2754 1.25 17.996 1.25V2.75ZM18.9881 4.76042L14.054 11.1978L15.2445 12.1103L20.1786 5.67293L18.9881 4.76042ZM13.8993 11.654V19.3269H15.3993V11.654H13.8993ZM14.2919 18.6675L9.35931 21.3406L10.074 22.6594L15.0066 19.9863L14.2919 18.6675ZM10.4667 22V11.8059H8.96665V22H10.4667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.15bd4a48e338fa646b79b709ca54e833.svg";
export { ForwardRef as ReactComponent };